import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { CurrentUserService } from 'services/currentUser';
import { TransitionService } from '@uirouter/angularjs';
import { getLoginSref, getPoliciesSref } from 'components/navigation/shared/states';

const module = angular.module('mobile-header', []);

interface MobileHeaderController extends angular.IComponentController {
    userIsLoggedIn: boolean;
}

module.component('mobileHeader', {
    template: template,
    controller: function(
        this: MobileHeaderController,
        currentUserService: CurrentUserService,
        $transitions: TransitionService
    ) {
        this.$onInit = () => {
            this.getPoliciesSref = getPoliciesSref;
            this.getLoginSref = getLoginSref;
            this.userIsLoggedIn = currentUserService.isLoggedIn();

            $transitions.onSuccess({}, () => {
                this.userIsLoggedIn = currentUserService.isLoggedIn();
            });
        };
    }
});

export { module };
